angular.module('arounja.services', [])
    .constant('restConfig', {
        root: dynamicRoot + 'wp-json/',
        endpoint: dynamicRoot + "wp-json/arounja/v1"
    })
    .constant('taxonomyConfig', {
        root : 1
    });